import { gql } from '@apollo/client'

export const CREATE_UPLOAD_MUTATION = gql`
  mutation createUpload($attributes: UploadInput!) {
    createUpload(attributes: $attributes) {
      createdAt
      updatedAt
      attachmentUrl
      attachmentFilename
    }
  }
`
